import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=71a2450c&"
import script from "./ContractList.vue?vue&type=script&lang=js&"
export * from "./ContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports